export const config = {
  title: "Cannon",
  company_logo: "cannon_logo.png",
  logo_placements: [],
  show_image_preview: false,
  embroideries: {
    hat: [],
    mens: [],
    womens: [],
    accessory: [],
    customs: [],
    office: [],
    service: [],
  },
  email_recipients: ["lbudbill@gpcorp.com", "lbudbell@comcast.net"],
  stores: [
    {
      name: "Cannon Ford of Cleveland",
      address: "",
      code: "CANFCL",
    },
    {
      name: "Cannon Ford of Starkville",
      address: "",
      code: "CANLST",
    },
    {
      name: "Cannon Chevrolet Buick GMC",
      address: "",
      code: "CANBCL",
    },
    {
      name: "Cannon Chevrolet Greenwood",
      address: "",
      code: "CANCGR",
    },
    {
      name: "Cannon Chevrolet Buick GMC of West Point",
      address: "",
      code: "CANCWE",
    },
    {
      name: "Cannon Chevrolet Buick Cadillac of Oxford",
      address: "",
      code: "CANCOX",
    },
    {
      name: "Cannon Honda",
      address: "",
      code: "CANHPO",
    },
    {
      name: "Cannon CDJR of Cleveland",
      address: "",
      code: "CANCCL",
    },
    {
      name: "Cannon Ford of Pascagoula",
      address: "",
      code: "CANFPA",
    },
    {
      name: "Cannon CDJR Greenwood",
      address: "",
      code: "CANCGE",
    },
    {
      name: "Cannon Preowned Grenada",
      address: "",
      code: "CANPGR",
    },
    {
      name: "Cannon Toyota of Vicksburg",
      address: "",
      code: "CANTVI",
    },
    {
      name: "Cannon Toyota of Mosspoint",
      address: "",
      code: "CANTMO",
    },
    {
      name: "Cannon Nissan of Moss Point",
      address: "",
      code: "CANNMO",
    },
    {
      name: "Cannon CDJR of West Point",
      address: "",
      code: "CANDWE",
    },
    {
      name: "Cannon Preowned of Jackson",
      address: "",
      code: "CANPJA",
    },
    {
      name: "Cannon Preowned Calhoun City",
      address: "",
      code: "CANPCC",
    },
    {
      name: "Cannon Nissan of Greenwood",
      address: "",
      code: "CANNGR",
    },
    {
      name: "Cannon Nissan of Jackson",
      address: "",
      code: "CANNJA",
    },
    {
      name: "Cannon Nissan of Oxford",
      address: "",
      code: "CANNOX",
    },
    {
      name: "Grenada Nissan",
      address: "",
      code: "GREIGR",
    },
    {
      name: "Cannon Chevrolet Nissan of Laurel",
      address: "",
      code: "CANCLR",
    },
    {
      name: "Cannon GMC Vicksburg",
      address: "",
      code: "CANBVI",
    },
    {
      name: "Cannon CDJR Senatobia",
      address: "",
      code: "CANCSE",
    },
  ],
  bypass_codes: ["CANNJA"],
  server_hostname: "https://o1yn7lpenj.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Louis Budbill", phone: "678-287-1659" },
    { name: "Glenn Rodney", phone: "678-287-1608" },
  ],
};
